import * as THREE from "three";
import { createLabel } from "../../../TOOLS/LabelFactory";

export class Colleague {

  constructor(store, parent, label, id, position, picture) {
    this.store = store;
    this.parent = parent;
    this.label = label;
    this.id = id;
    this.picture = picture;
    this.nameLabel = null;
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.group.position.copy(position);
    this.meshGroup = new THREE.Group();
    this.group.add(this.meshGroup);
    this.createMesh();
  }

 createMesh() {
  const geometry = this.store.config.isSmall ? new THREE.CylinderGeometry(.7, .7, 0.08, 32) : new THREE.CylinderGeometry(.4, .4, 0.08, 32);
  const fileName = this.label.toLowerCase().replaceAll(" ", "_");
  const loader = new THREE.TextureLoader();
  const texture = loader.load(`/assets/faces/${this.picture}`,
    () => {},
    undefined,
    () => {
      loader.load('/assets/faces/xxx.png', (defaultTexture) => {
        defaultTexture.colorSpace = THREE.SRGBColorSpace;
        defaultTexture.center.set(0.5, 0.5);
        defaultTexture.rotation = Math.PI / 2;
        topMaterial.map = defaultTexture;
        topMaterial.needsUpdate = true;
      });
    }
  );
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.center.set(0.5, 0.5);
  texture.rotation = Math.PI / 2;
  const sideMaterial = new THREE.MeshStandardMaterial({color: 0x888888, roughness: 0.35, metalness: 0.15});
  const topMaterial = new THREE.MeshStandardMaterial({map: texture, roughness: 0.8, metalness: 0});
  const bottomMaterial = new THREE.MeshStandardMaterial({color: 0x666666});
  const materials = [sideMaterial, topMaterial, bottomMaterial];
  this.mesh = new THREE.Mesh(geometry, materials);
  this.mesh.rotation.x = THREE.MathUtils.degToRad(60);
  this.mesh.castShadow = true;
  this.mesh.receiveShadow = true;
  this.mesh.userData.type = 'colleague';
  this.mesh.userData.instance = this;
  this.store.input.clickables.push(this.mesh);
  this.nameLabel = createLabel(this.label, {fontSize: this.store.config.isSmall ? 16 : 12, position: new THREE.Vector3(0, -.4, 0)});
  this.meshGroup.add(this.nameLabel);
  this.meshGroup.add(this.mesh);
}

 update() {
    this.group.updateWorldMatrix(true, true);
  }

  getWorldPosition() {return this.group.getWorldPosition(new THREE.Vector3());}

  dispose() {
    this.mesh.geometry.dispose();
    if (Array.isArray(this.mesh.material)) {
      this.mesh.material.forEach(material => {
        material.dispose();
        if (material.map) {material.map.dispose();}
      });
    } else {
      this.mesh.material.dispose();
      if (this.mesh.material.map) {this.mesh.material.map.dispose();}
    }
    this.parent.remove(this.group);
    if (this.modal) {this.modal.remove();}
  }

}